import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ButtonGroup extends Component {

  render() {
    const {label, className} = this.props;

    let buttons;
    if(this.props.children) {
      buttons = this.props.children.map((item, i)=>{
        return React.cloneElement(item, {
            key: i,
            onChange: this.props.onChange
        });
      });
    }

    return (
      <div className={'button-group ' + (className || '')}>
        {buttons}
      </div>
    );
  }
}

ButtonGroup.propTypes = {
    label: PropTypes.string,
  className: PropTypes.any,
  children: PropTypes.any,
  onChange: PropTypes.any,
};

export default ButtonGroup;
